import DropdownBody from './DropdownBody'
export default DropdownBody



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/components/DropdownBody/index.js